import axios from 'axios'
import moment from 'moment'
import Vue from 'vue'

import * as availabilityAPI from '@api/availability'
import * as types from '@store/mutation-types'

const state = {
  date: moment().startOf( 'day' ),
  time: null,
  location: null,
  partySize: 2,
  firstTimeslot: null,
  lastTimeslot: null,
  disableSearch: false,
  showPage: null,
  suggestedTimes: {
    requested: null,
    prior: null,
    next: null,
    selected: null,
  },
  heartbeats: {
    winston: true,
    greensboro: true
  },
  heartbeatsOfflineCounter: {
    winston: 0,
    greensboro: 0
  }
}

const mutations = {
  [ types.UPDATE_HEARTBEATS ]( state, { hb, first } ) {
    
    //this is convoluted... need to refactor. this forEach either 
    //  resets the heartbeatsOfflineCounter to 0 if location is up
    //  or increases the counter by 1 if location is down
    Object.keys( hb ).forEach( loc => {
      if ( ['winston','greensboro'].includes( loc ) ) {
        if ( hb[ loc ] ) {
          Vue.set( state.heartbeatsOfflineCounter, loc, 0 )
        } else {
          let count = state.heartbeatsOfflineCounter[ loc ]
          Vue.set( state.heartbeatsOfflineCounter, loc, count + 1 )
        }
      }
    } )
    
    //this forEach sets location offline if heartbeat receives an offline signal for more than 2 beats
    //done this way so that two offline signals have to be received in a row to disable that location
    Object.keys( hb ).forEach( loc => {
      if ( ['winston','greensboro'].includes( loc ) ) {
        let count = state.heartbeatsOfflineCounter[ loc ]
        Vue.set( state.heartbeats, loc, count <= 2 )
      }
    } )

    if ( first ) {
      Object.keys( hb ).forEach( loc => {
        if ( ['winston','greensboro'].includes( loc ) ) {
          Vue.set( state.heartbeats, loc, hb[ loc ] )
        }
      } )
    }


  },
  [ types.UPDATE_DATE ]( state, val ) {
    state.date = moment( val, "MM-DD-YYYY" )
  },
  [ types.UPDATE_TIME ]( state, val ) {
    state.time = val
  },
  [ types.UPDATE_LOCATION ]( state, val ) {
    state.location = val
  },
  [ types.UPDATE_PARTY_SIZE ]( state, val ) {
    state.partySize = val
  },
  [ types.UPDATE_FIRST_TIMESLOT ]( state, val ) {
    state.firstTimeslot = val
  },
  [ types.UPDATE_LAST_TIMESLOT ]( state, val ) {
    state.lastTimeslot = val
  },
  [ types.UPDATE_DISABLE_SEARCH ]( state, val ) {
    state.disableSearch = val
  },
  [ types.SET_SUGGESTED_TIMES ]( state, {
    requested,
    prior,
    next
  } ) {
    state.suggestedTimes.requested = requested
    state.suggestedTimes.prior = prior
    state.suggestedTimes.next = next
  },
  [ types.CLEAR_SUGGESTED_TIMES ]( state ) {
    state.suggestedTimes.requested = null
    state.suggestedTimes.prior = null
    state.suggestedTimes.next = null
  },
  [ types.SELECT_SUGGESTED_TIME ]( state, val ) {
    state.suggestedTimes.selected = val
  },
  [ types.SET_SHOW_PAGE ]( state, val ) {
    state.showPage = val
  }
}

const actions = {
  heartbeatTimer( { dispatch } ) {
    dispatch( "updateHeartbeats", true )
    
    setTimeout( _ => {
      dispatch( "updateHeartbeats", true )
      setInterval( _ => {
  
        dispatch( "updateHeartbeats", false )
      }, 5 * 1000 )
    }, 5 * 1000)
  },
  async updateHeartbeats( { commit }, first ) {
    let response = await availabilityAPI.getHeartbeats()
    if ( response && response.data ) {
      commit( 'UPDATE_HEARTBEATS', {hb: response.data, first } )
    }
  },
  async getUpdatedTimes( {
    commit,
    state,
  }, {
    location,
    date
  } ) {
    try {
      let response = await availabilityAPI.getUpdatedTimes( location, date )
      if ( response.data && response.data.first_timeslot && response.data.last_timeslot ) {
        commit( 'UPDATE_FIRST_TIMESLOT', response.data.first_timeslot )
        commit( 'UPDATE_LAST_TIMESLOT', response.data.last_timeslot )
      }
    } catch( error ) {

    }

  },

  async getSuggestedTimes( {
    commit,
    state,
  }, {
    location,
    date,
    time,
    partySize,
    res_token,
  } ) {
    try {
      let response = await availabilityAPI.getSuggestedTimes( location, date, time, partySize, res_token )
      if ( response.data ) {
        commit( "SET_SUGGESTED_TIMES", response.data )
      }
    } catch( error ) {

    }
  },
  setResInfo( { commit }, info ) {
    let date = moment( info.date, "MM-DD-YYYY" )
    commit( "UPDATE_DATE", date )

    let time = resTimeToText( info.time )
    commit( "UPDATE_TIME", time )
    commit( "UPDATE_LOCATION", info.location )
    commit( "UPDATE_PARTY_SIZE", info.partySize )

  },
  showReservationCreator( { commit } ) {
    commit( "SET_SHOW_PAGE", "reservation" )
  },
  async getCurrentTime() {
    return await availabilityAPI.getCurrentTime() 
  }
}

function resTimeToText( time ) {
  let timeSplitTemp = time.toString().split(".")
  let hour = timeSplitTemp[0]
  let minute = timeSplitTemp[1]
  if ( hour == 0 ) { hour = 12 }

  let textHour = hour.toString().padStart( 2, '0' )
  let textMinute = minute == 0.0 ? "00" : "30"

  return `${ textHour }:${ textMinute }`
}

export default {
  state,
  // getters,
  actions,
  mutations,
  namespaced: true
}